namespace appn.views.embeddedContent.index {

    class InitArgs {
        linkAction: string = appn.emptyString;
        url: string = appn.emptyString;
        title: string = appn.emptyString;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        addEvents();

        $('section.content').css('padding', '0px');
        appn.dialog.showLoading(_initArgs.title);

        if (_initArgs.linkAction === 'POST') {
            $('#iframePostForm').submit();
            return;
        }

        // Just a GET so set the src.
        $('iframe[name=contentIframe]').prop('src', _initArgs.url);

        setTimeout(function() {
            appn.dialog.hideLoading();
        }, 10000);
    }

    function addEvents() {
        $('iframe[name=contentIframe]').on('load', function() {
            appn.dialog.hideLoading();
        });
    }
}
